export enum SystemNumberTypeEnum {
  LOCAL = 'LOCAL',
  TOLL_FREE = 'TOLL_FREE',
}
